// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"a413037f","254":"d2493fae","386":"c77feeaf","773":"441a3505","859":"e5903a4b"}[chunkId] + ".chunk.css";
};